import dashboardReducer from "./Dashboard/DashboardReducer";
import buildingsReducer from "./Buildings/BuildingsReducer";
import bookingsReducer from "./Bookings/BookingsReducer";
import reportsReducer from "./Reports/ReportsReducer";
import profileReducer from "./Profile/ProfileReducer";
import membersReducer from "./Members/MembersReducer";
import groupsReducer from "./Groups/GroupsReducer";
import couponReducer from "./Coupon/CouponReducer";
import { configureStore } from "@reduxjs/toolkit";
import usersReducer from "./Users/UsersReducer";
import authReducer from "./Auth/AuthReducer";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    dashboard: dashboardReducer,
    profile: profileReducer,
    bookings: bookingsReducer,
    buildings: buildingsReducer,
    users: usersReducer,
    members: membersReducer,
    reports: reportsReducer,
    groups: groupsReducer,
    coupons: couponReducer,
  },
});

export type ErrorType = {
  error: string;
  message: string;
  response: any;
  status: number;
};
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
